import { ExpandLess, ExpandMore } from "@mui/icons-material"
import { Box, Collapse, ListItemButton, ListItemText, TextField, List } from "@mui/material"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const DeferralFilter = (props) => {

    const {
        handleClick4,
        fourthListopen,
        handleMonthFilter,
        handleClick8,
        eightListopen,
        handleYearFilter,
        intakeMonth,
        intakeYear
    } = props

    return (
        <>
            <ListItemButton onClick={handleClick4}>
                <ListItemText
                    primary="next intake month"
                    sx={{ textTransform: "capitalize" }}
                />
                {fourthListopen ? (
                    <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
                ) : (
                    <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
                )}
            </ListItemButton>
            <Collapse in={fourthListopen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton>
                        <Box sx={{ mt: 1 }}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    views={["month"]}
                                    label="Month"
                                    value={intakeMonth}
                                    sx={{ width: 200 }}
                                    onChange={(newValue) => handleMonthFilter(newValue, "month")}
                                    renderInput={(params) => (
                                        <TextField {...params} fullWidth />
                                    )}
                                />
                            </LocalizationProvider>
                            {/* <Typography>{error?.intakeMonth}</Typography> */}
                        </Box>
                    </ListItemButton>
                </List>
            </Collapse>
            <ListItemButton onClick={handleClick8}>
                <ListItemText
                    primary="next intake year"
                    sx={{ textTransform: "capitalize" }}
                />
                {eightListopen ? (
                    <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
                ) : (
                    <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
                )}
            </ListItemButton>
            <Collapse in={eightListopen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton>
                        <Box sx={{ mt: 3 }}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    views={["year"]}
                                    label="Year"
                                    value={intakeYear}
                                    sx={{ width: 200 }}
                                    onChange={(newValue) => handleYearFilter(newValue, "year")}
                                    renderInput={(params) => (
                                        <TextField {...params} fullWidth />
                                    )}
                                />
                            </LocalizationProvider>
                        </Box>
                    </ListItemButton>
                </List>
            </Collapse>
        </>
    )
}

export default DeferralFilter